export const environment = {
  API_HOST: 'https://api.kvpn.app',
  WS_HOST: 'https://api.kvpn.app',
  TELEGRAM_CLIENT_ID: 7945257572,
  VK_CLIENT_ID: 54474938,
  SENTRY_ENABLED: true,
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyCGP7lLfN5eWEtBTijbQUp-9oKH3_UwGY8",
    authDomain: "auth.kvpn.app",
    projectId: "kotlinvpn",
    storageBucket: "kotlinvpn.firebasestorage.app",
    messagingSenderId: "1044952868892",
    appId: "1:1044952868892:web:fa4d6db40dfdc417d197d9",
    measurementId: "G-6JBFWSENNW"
  }
};
